import type { FC } from "react";
import { CircularProgressBar } from ".";

type LoadingSpinnerProps = {
  progressColor?: string;
  backgroundColor?: string;
  sizeClasses?: string;
};

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({
  progressColor = "text-white",
  backgroundColor = "text-gray-100/10",
  sizeClasses = "w-20 h-6",
}) => (
  <CircularProgressBar
    progressPercentage={20}
    className="-mt-0.5 animate-spin"
    progressColor={progressColor}
    backgroundColor={backgroundColor}
    sizeClasses={`mx-auto ${sizeClasses}`}
  />
);
